import type { ComponentType } from 'react';
import type { GameModuleProps, ModuleType } from '../types/game';
import { MemoryModule } from './MemoryModule';
import { MultipleChoiceModule } from './MultipleChoiceModule';
import { PhotoPuzzleModule } from './PhotoPuzzleModule';
import { RiddleModule } from './RiddleModule';
import { SecretCodeModule } from './SecretCodeModule';
import { StoryModule } from './StoryModule';
import { TextAnswerModule } from './TextAnswerModule';

type RegisteredComponent = ComponentType<GameModuleProps<ModuleType>>;

export const moduleRegistry: Record<ModuleType, RegisteredComponent> = {
  story: StoryModule as RegisteredComponent,
  'multiple-choice': MultipleChoiceModule as RegisteredComponent,
  'text-answer': TextAnswerModule as RegisteredComponent,
  riddle: RiddleModule as RegisteredComponent,
  'secret-code': SecretCodeModule as RegisteredComponent,
  memory: MemoryModule as RegisteredComponent,
  'photo-puzzle': PhotoPuzzleModule as RegisteredComponent,
};

